import React from 'react';
import clsx from 'classnames';
import './index.css';
import QueueAnim from 'rc-queue-anim';

const Content = () => {
  const serviceList = [
    {
      key: '01',
      title: '场地规划和设计',
      desc: '提供详细的场地布局、规划和设计，制定完整全面的建设方案。',
      color: '#026c98',
    },
    {
      key: '02',
      title: '设备及附件配置',
      desc: '提供多种不同规格、不同档次设备配置供客户选择；提供完整全面的试验用附件，无需客户额外配置。',
      color: '#d7204f',
    },
    {
      key: '03',
      title: '体系建设',
      desc: '提供满足实验室认可准则的完整实验室体系。',
      color: '#7ad720',
    },
    {
      key: '04',
      title: '管理软件开发',
      desc: '定制检测实验室的相关管理软件，提高实验室工作效率和管理水平。',
      color: '#e0a527',
    },
    {
      key: '05',
      title: '库房建设',
      desc: '定制安全工器具专用库房、绝缘斗臂车专用库房。',
      color: '#2083d7',
    },
    {
      key: '06',
      title: '技术培训',
      desc: '提供专业的检测技术、体系、实验室管理等培训服务。',
      color: '#b720d7',
    },
  ];

  return (
    <QueueAnim
      className={clsx('servicecontent-content')}
      type={['bottom', 'top']}
    >
      <div
        className={clsx('servicecontent-content-title')}
        key='servicecontent-content-title'
      >
        服务内容
      </div>
      <div
        className={clsx('servicecontent-content-list')}
        key='servicecontent-content-list'
      >
        {serviceList.map((item) => (
          <div
            className={clsx('servicecontent-content-list-item')}
            key={item.key}
          >
            <div className={clsx('servicecontent-content-list-item-top')}>
              <div
                className={clsx('servicecontent-content-list-item-top-num')}
                style={{ color: item.color }}
              >
                {item.key}
              </div>
              <div
                className={clsx('servicecontent-content-list-item-top-title')}
              >
                {item.title}
              </div>
            </div>
            <div className={clsx('servicecontent-content-list-item-desc')}>
              {item.desc}
            </div>
          </div>
        ))}
      </div>
    </QueueAnim>
  );
};

export default Content;
